export default __webpack_public_path__ + "static/media/partOfCard.5559fe89.png";